package br.com.texeratx.boardgametimeapp.data.repository

import br.com.texeratx.boardgametimeapp.core.network.ApiClient
import br.com.texeratx.boardgametimeapp.core.session.SessionManager
import br.com.texeratx.boardgametimeapp.data.model.player.CreatePlayerRequest
import br.com.texeratx.boardgametimeapp.data.model.player.PlayerDetailDTO
import br.com.texeratx.boardgametimeapp.data.model.player.PlayerDTO
import br.com.texeratx.boardgametimeapp.data.model.player.PlayerNameDTO
import br.com.texeratx.boardgametimeapp.data.model.player.UpdatePlayerRequest
import io.ktor.client.call.body

class PlayerRepository(
    private val api: ApiClient,
    private val sessionManager: SessionManager
) {

    suspend fun getPlayers() = runCatching {
        val response = api.get("players")
        response.body<List<PlayerDTO>>()
    }

    suspend fun getPlayerById(playerId: Long): Result<PlayerDTO> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            val response = api.get("players/$playerId")
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun getPlayerDetailById(playerId: Long): Result<PlayerDetailDTO> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("SessÃ£o expirada"))
            val response = api.get("players/$playerId")
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun updatePlayer(
        playerId: Long,
        request: UpdatePlayerRequest
    ): Result<Unit> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            api.put("players/$playerId", request)
            Result.success(Unit)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun createPlayer(body: CreatePlayerRequest): Result<Unit> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            api.post("players", body)
            Result.success(Unit)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun getPlayersName(): Result<List<PlayerNameDTO>> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            val response = api.get("players/name")
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
    suspend fun deletePlayer(playerId: Long): Result<Unit> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("SessÃ£o expirada"))
            api.delete("players/$playerId")
            Result.success(Unit)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}
